import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PathTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Save the last path before updating
    const prev = sessionStorage.getItem("currentPath");
    if (prev) {
      sessionStorage.setItem("prevPath", prev);
    }
    sessionStorage.setItem("currentPath", location.pathname);
  }, [location.pathname]);

  return null; // invisible helper
};

export default PathTracker;
